import { render, staticRenderFns } from "./OrderReceipt.vue?vue&type=template&id=e2e1b8c4&scoped=true&"
import script from "./OrderReceipt.vue?vue&type=script&lang=js&"
export * from "./OrderReceipt.vue?vue&type=script&lang=js&"
import style0 from "./OrderReceipt.vue?vue&type=style&index=0&id=e2e1b8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e1b8c4",
  null
  
)

export default component.exports